export default ({axios, mapQueryString, withoutInvalidValues}) => ({
    list: (query = {}) => axios.get(`/external-booking-visits${mapQueryString(withoutInvalidValues(query))}`),
    show: (id, query = {}) => axios.get(`/external-booking-visits/${id}${mapQueryString(query)}`),
})
